
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M22 11.75C22 7.08337 17.5 3.33337 12 3.33337C6.5 3.33337 2 7.08337 2 11.6667C2 16.25 6.5 20 12 20C12.8395 19.9994 13.677 19.9157 14.5 19.75L19.1667 21.5834C19.25 21.5834 19.3333 21.6667 19.5 21.6667C19.6771 21.6494 19.848 21.5924 20 21.5C20.1107 21.4101 20.1986 21.2953 20.2566 21.165C20.3145 21.0347 20.3408 20.8925 20.3333 20.75L19.9167 16.8334C21.2168 15.4555 21.9592 13.6441 22 11.75ZM13.005 7.50004L12.8079 10.25L12.6108 13H11.3892L11.0175 7.50004H13.005ZM12 16.6667C11.7582 16.6667 11.5219 16.595 11.3208 16.4607C11.1198 16.3263 10.9631 16.1354 10.8706 15.912C10.778 15.6887 10.7538 15.4429 10.801 15.2057C10.8482 14.9686 10.9646 14.7507 11.1356 14.5798C11.3065 14.4088 11.5244 14.2924 11.7615 14.2452C11.9986 14.198 12.2444 14.2222 12.4678 14.3148C12.6912 14.4073 12.8821 14.564 13.0165 14.765C13.1508 14.9661 13.2225 15.2024 13.2225 15.4442C13.2225 15.7684 13.0937 16.0794 12.8644 16.3086C12.6352 16.5379 12.3242 16.6667 12 16.6667Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowmsgFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
